<template class="pb-10">
  <div>
    <nav v-if="!isMobile">
      <v-app-bar app prominent dense>
        <v-container class="d-flex justify-center">
          <DateTimePicker :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :isClose="isClose" :selectD="selectD" />
        </v-container>
        <div style="padding-top:10px" class="d-flex">
          <v-btn class="mr-2" color="info darken-1" small fab v-if="resetTimeRange" @click="resetTrange(loadsEvent)">
            <v-icon color="white">mdi-restart</v-icon>
          </v-btn>
          <v-btn v-on="on" color="info" small fab @click="darkMode">
            <v-icon color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </nav>
    <v-container class="text-center mt-3" v-else>
      <DateTimePickerMobile :values1="dateTime1" :values2="dateTime2" :updateData="updateData" :dateApplied="dateApplied" :isClose="isClose" :selectD="selectD" />
    </v-container>
    <v-card-title>Alerts ({{event.length}})</v-card-title>
    <v-card-text v-if="smpEvent.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
    <v-card-text class="d-flex justify-center" v-else>
      <v-lazy v-if="!isMobile">
        <AlertPieChart :breachTypes="breachTypes" :countSeismic="countSeismic" :countNoise="countNoise" :countParticle="countParticle" :countHzdGas="countHzdGas" :countWeather="countWeather" v-if="renderComponent" />
      </v-lazy>
      <v-lazy v-else>
        <AlertPieChart :breachTypes="breachTypes" :countSeismic="countSeismic" :countNoise="countNoise" :countParticle="countParticle" :countHzdGas="countHzdGas" :countWeather="countWeather" v-if="renderComponent" isMobile='true' />
      </v-lazy>
    </v-card-text>
    <v-row class="ma-0">
      <v-col class="pa-3 d-flex flex-column">
        <v-simple-table height="500px" v-if="smpEvent.length" class="px-1">
          <template v-slot:default>
            <thead class="text-center">
              <tr>
                <th class="text-center" style="width:5%">
                  #
                </th>
                <th class="text-center" style="width:15%">
                  Date
                </th>
                <th class="text-center">
                  Time (24-hour)
                </th>
                <th class="text-center">
                  Origin
                </th>
                <th class="text-center">
                  Type
                </th>
                <th class="text-center" style="width:40%">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in event" :key="idx">
                <td>{{idx + 1}}</td>
                <td>{{ formatDay(item.timestamp) }} {{formatMonth(item.timestamp)}} {{formatYear(item.timestamp)}}</td>
                <td>{{ formatTimeTd(item.timestamp) }}</td>
                <td>{{ item.location }}</td>
                <td>{{ eventType(item.fields.event_id, item.fields.air_quality_data.co, item.fields.air_quality_data.no2, item.fields.air_quality_data.nh3,
             item.fields.weather_data.amb_temp, item.fields.weather_data.humidity) }} </td>
                <td>{{ eventDesc(item.fields.event_id, item.fields.seismic_data.mag, item.fields.seismic_data.angle,
             item.fields.sound_data.sound, item.fields.sound_data.evt_duration, 
             item.fields.air_quality_data.density, item.fields.air_quality_data.co, item.fields.air_quality_data.no2, item.fields.air_quality_data.nh3,
             item.fields.weather_data.amb_temp, item.fields.weather_data.humidity) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DateTimePicker from '../../components/DateTimePicker.vue'
import DateTimePickerMobile from '../../components/DateTimePickerMobile.vue';
import AlertPieChart from '../../components/AlertPieChart.vue'



import moment from 'moment'
import axios from 'axios'
import { mapActions, mapGetters } from "vuex";

class Event {
  constructor(name, value) {
    this.name = name;
    this.value = value;
    this.time = new Date();
  }
}

export default {
    components: {
        DateTimePicker,
        DateTimePickerMobile,
        AlertPieChart,
    },

    data() {
        return {
          clicked: 0,
          isMobile: true,
          isClose: true,
          renderComponent: true,
          polling: null,
          event: [],
          smpEvent : [],
          co: [],
          nh3: [],
          no2: [],
          temp: [],
          humid: [],
          events: [],
          breachTypes: ["Seismic", "Noise", "Dust(PM2.5)", "Hazardous Gas", 'Weather'],
        }
    },
  methods: {
    ...mapActions(["resetTrange"]),
      async forceRender() {
        this.renderComponent = false;
        await this.$nextTick();
        this.renderComponent = true;
      },
      dateApplied(date1, date2) {
        this.events.unshift(
          new Event("date-applied", `${date1.toString()}`)
       );
        this.values1 = this.events[0].value;
        this.events.unshift(
        new Event("date-applied", `${date2.toString()}`)
       )
        this.values2 = this.events[0].value;
        this.updateData(this.events)
        this.isClose = true;
        this.clicked = 0;
      },
    selectD(date1, date2) {
        this.clicked++        
        if(this.clicked === 2) {
            this.dateApplied(date1, date2);
            this.clicked = 0;
        }  
      },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    updateData(values){
      this.$store.commit('setReset', true);

      this.values1 = values[1].value;
      this.values2 = values[0].value;
      this.$store.commit('setDateTime1', this.values1)
      this.$store.commit('setDateTime2', this.values2)

      if(moment(this.values2).diff(moment(this.values1), 'minutes') == 60 && moment(this.values2) == moment()){
        this.values1 = moment().subtract(1, "hour").toDate();
        this.values2 = moment().toDate();
        this.loadsSmp();
      }
      else if(moment(this.values2).diff(moment(this.values1), 'minutes') == 180 && moment(this.values2) == moment()){
        this.values1 = moment().subtract(3, "hour").toDate();
        this.values2 = moment().toDate();
        this.loadsSmp();
      }
      else if(moment(this.values2).diff(moment(this.values1), 'minutes') == 720 && moment(this.values2) == moment()){
        this.values1 = moment().subtract(12, "hour").toDate();
        this.values2 = moment().toDate();
        this.loadsSmp();
      }
      else {
        this.values1 = values[1].value;
        this.values2 = values[0].value;
        this.loadsEvent();
      }
    },
    formatDateTd(value) {
      return moment(value).format("DD MMM YY")
    },
    formatTimeTd(value) {
      return moment(value).format("HH:mm:ss")
    },
    formatDay(value) {
      return moment(value).format("DD")
    },
    formatMonth(value) {
      return moment(value).format("MMMM")
    },
    formatYear(value) {
      return moment(value).format("YYYY")
    },
    eventDesc(value, mag, angle, soundDb, duration_sound, density, co, noTwo, nhThree, temp, humid) {
      var velo = mag;
      var tilt = angle;
      var noise = soundDb;
      var soundDura = duration_sound;
      var dust = density;
      var cbnDxd = co;
      var ntgDxd = noTwo;
      var amnia = nhThree;
      var tempe = temp;
      var humidi = humid;
      switch (value) {
          case 13:
            return `Peak Vibration Level : ${velo} mm/s. Max ALLOWED is 5.0mm/s..`;
          case 14:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 15:
            return `Severe tilting detected: ${tilt}° from previous position`;
          case 16:
            return "Peak Particles Velocity(PPV) continuously > ALLOWED 5.0 mm/s for 1m 20sec.";
          case 17:
            return "Unit enclosure is OPENED!";
          case 18:
            return `Noise level > ALLOWED 80 dBa and lasted OVER ${soundDura} seconds limit`;
          case 19:  
            return `Noise Peak Level: ${noise} dBa. Limit is 90 dBa(7am-7pm) & 85 dBa(7pm-7am)`;
          case 21:
            return `Noise Continuous Breached at ${noise} dBa. Duration recorded: ${soundDura} secs.`;
          case 22:
            return `Dust Level (PM2.5) breach at: ${dust} ug/m3.`;
          case 29:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 31:
            return "Unit enclosure is CLOSED!";
            default:
              if(cbnDxd > 30) {
                return `Carbon Monoxide (CO) Level: ${cbnDxd}mg/m. Threshold is 30mg/m3.`   
              }
              else if(ntgDxd > 280) {
                return `Nitrogen Dioxide (NO2) Level: ${ntgDxd}µg/m3. Threshold is 280µg/m3.`   
              }
              else if(amnia > 1.5) {
                return `Ammonia (NH3) Level: ${amnia}mg/m. Threshold is 1.5mg/m3.`   
              }
              else if(tempe > 45) {
                return `Ambient Temperature: ${tempe}°C. Threshold is 45°C.`   
              }
              else if(humidi > 99) {
                return `Humidity: ${humidi}%RH. Threshold is 99%RH.`   
              }
            }
        },
    eventType(value, co, noTwo, nhThree, temp, humid) {
        var cbnDxd = co;
        var ntgDxd = noTwo;
        var amnia = nhThree;
        var tempe = temp;
        var humidi = humid;
        switch (value) {
            case 13:
              return 'Seismic' 
            case 14:
              return 'Seismic' 
            case 15:
              return 'Seismic' 
            case 16:
              return 'Particles' 
            case 17:
              return "Unit enclosure is OPENED!";
            case 18:
              return 'Noise' 
            case 19:  
              return 'Noise' 
            case 21:
              return 'Noise' 
            case 22:
              return 'Dust' 
            case 29:
              return 'Seismic' 
            case 31:
              return "Unit enclosure is CLOSED!";
            default: {
              if (cbnDxd > 30 || amnia > 1.5 || ntgDxd > 280 ){
                return "Hazardous Gas"
              }
              else if (tempe > 45 || humidi > 99){
                return "Weather"
              }
              }
            }
        },
    async loadsEvent(){
        let apiURL =  process.env.VUE_APP_API + "/api/smp/alert-list/" + this.dateTime1 + '-'+ this.dateTime2;
        await axios.get(apiURL).then(res => {
            this.event = res.data;
            this.smpEvent = res.data.map((event) => event.fields.event_id);
            this.co = res.data.filter((co) => co.fields.event_id == 0 || co.fields.event_id == 30).map((co) => co.fields.air_quality_data.co);
            this.nh3 = res.data.filter((nh3) => nh3.fields.event_id == 0 || nh3.fields.event_id == 30).map((nh3) => nh3.fields.air_quality_data.nh3);
            this.no2 = res.data.filter((no2) => no2.fields.event_id == 0 || no2.fields.event_id == 30).map((no2) => no2.fields.air_quality_data.no2);
            this.temp = res.data.filter((temp) => temp.fields.event_id == 0 || temp.fields.event_id == 30).map((temp) => temp.fields.weather_data.amb_temp);
            this.humid = res.data.filter((humid) => humid.fields.event_id == 0 || humid.fields.event_id == 30).map((humid) => humid.fields.weather_data.humidity);
            }).catch(error => {
                console.log(error)
            });
            this.forceRender()
        },
    },
    computed: {
      ...mapGetters(["dateTime1", "dateTime2", "resetTimeRange"]),
      height () {
      var view = this.$vuetify.breakpoint.name;
        switch (view) {
          case 'xs': return 120;
          case 'sm': return 140;
          case 'md': return 160;
          case 'lg': return 180;
          case 'xl': return 200;
        }
        return view
      },
      width () {
      var view = this.$vuetify.breakpoint.name;
        switch (view) {
          case 'xs': return 200;
          case 'sm': return 500;
          case 'md': return 600;
          case 'lg': return 700;
          case 'xl': return 1000;
        }
        return view
      },
      countSeismic() {
        let event = this.smpEvent
        var a = event.filter(function(value){
        return value === 13;
        }).length;
        var b = event.filter(function(value){
        return value === 14;
        }).length;
        var c = event.filter(function(value){
        return value === 15;
        }).length;
        var d = event.filter(function(value){
        return value === 29;
        }).length;
        return a + b + c + d
      },
      countNoise(){
          var event = this.smpEvent;
          var a = event.filter(function(value){
          return value === 18;
          }).length;
          var b = event.filter(function(value){
          return value === 19;
          }).length;
          var c = event.filter(function(value){
          return value === 21;
          }).length;
          return a + b + c; 
      },
      countParticle(){
          var event = this.smpEvent;
          var a = event.filter(function(value){
          return value === 22;
          }).length;
          var b = event.filter(function(value){
          return value === 16;
          }).length;
          return a + b;  
      },
      countHzdGas(){
          var coEvent = this.co;
          var nh3Event = this.nh3;
          var no2Event = this.no2;
          var a = coEvent.filter(function(value){
          return value > 30;
          }).length;
          var b = nh3Event.filter(function(value){
          return value > 1.5;
          }).length;
          var c = no2Event.filter(function(value){
          return value > 280;
          }).length;
          return a + b + c
      },
      countWeather(){
          var tempEvent = this.temp;
          var humidEvent = this.humid;
          var a = tempEvent.filter(function(value){
          return value > 45;
          }).length;
          var b = humidEvent.filter(function(value){
          return value > 99;
          }).length;
          return a + b
      },
    },
   async created() {
        this.loadsEvent();
    },
    mounted() {
      this.onResize()
      window.addEventListener("resize", this.onResize, { passive: true });
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            if (theme === "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
        }
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
    }
}
</script>

<style scoped>
table,
th,
td {
  border: 2px groove;
  text-align: center;
}
th {
  background-color: rgb(213, 205, 205);
  position: sticky;
  top: 0;
  z-index: 1;
}
.navApp {
  z-index: 9999;
}
.cardTitle {
  text-align: center;
  font-size: 0.8vw;
  font-weight: bold;
}
.select {
  max-width: 10.2vw;
  font-size: 0.98vw;
}
</style>
